import React from 'react';
import { Link } from 'react-router-dom';

import Image from '../../assets/img/team/team-1-1.jpg';

const SingleTeam = (props) => {
  const { itemClass, teamImage, titleClass, authorName, specialist } = props;
  return (
    <div className={itemClass ? itemClass : 'it-team-item'}>
      <div className="it-team-thumb">
        <img src={teamImage ? teamImage : Image} alt="" />
      </div>
      <div className="it-team-content text-center">
        <div className="it-team-author-box">
          <h4 className="it-team-title">
            <Link
              className={titleClass ? titleClass : 'hover-anim'}
              to="/team-details"
            >
              {authorName ? authorName : 'Dr. Keely Evans'}
            </Link>
          </h4>
          <span>{specialist ? specialist : 'Cardiologist'}</span>
        </div>
        <div className="it-team-social">
          <a href="#">
            <i className="flaticon-facebook-app-symbol"></i>
          </a>
          <a href="#">
            <i className="flaticon-youtube"></i>
          </a>
          <a href="#">
            <i className="flaticon-twitter"></i>
          </a>
        </div>
      </div>
    </div>
  );
};

export default SingleTeam;
